var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4684 12C22.4684 17.2467 18.0235 21.5 12.5405 21.5C10.0972 21.5 7.8601 20.6555 6.13054 19.2548L20.1221 5.86638C21.5859 7.52139 22.4684 9.66207 22.4684 12ZM5.01711 18.1989L19.0187 4.80096C17.2799 3.36699 15.016 2.5 12.5405 2.5C7.0574 2.5 2.6125 6.75329 2.6125 12C2.6125 14.3688 3.51854 16.5351 5.01711 18.1989ZM24.036 12C24.036 18.0751 18.8893 23 12.5405 23C6.19166 23 1.04492 18.0751 1.04492 12C1.04492 5.92487 6.19166 1 12.5405 1C18.8893 1 24.036 5.92487 24.036 12Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSymbol);
export default __webpack_public_path__ + "static/media/NoSymbol.dbb94290bb1284d678348648cddb4b6a.svg";
export { ForwardRef as ReactComponent };